import React, { useState, useEffect } from "react";
import { Box, Container } from "@mui/system";
import { Button, Chip, Skeleton, Typography } from "@mui/material";
import he from "he";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { Link as RouterLink } from "react-router-dom";
import getTaxonomy from "../functions/getTaxonomy";
import { useQuery } from "@tanstack/react-query";

export default function PostBanner({ post }) {
  const [bgImage, setBgImage] = useState();

  let image =
    post?._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
    post?.featured_image_src;

  useEffect(() => {
    if (image) {
      setBgImage(image);
    }
  }, [image]);

  //if revision preview post
  const getFeaturedImage = useQuery({
    queryKey: [post?.parent],
    queryFn: () =>
      axios.get(
        `${WP_API_Settings.endpoint}wp/v2/posts/${post?.parent}?_embed`,
        {
          headers: {
            "X-WP-Nonce": WP_API_Settings.nonce,
          },
        }
      ),
    retry: 1,
    enabled: !!post?.parent && !image,
  });

  useEffect(() => {
    if (getFeaturedImage?.data?.data) {
      setBgImage(
        getFeaturedImage?.data?.data?._embedded?.["wp:featuredmedia"]?.[0]
          ?.source_url
      );
    }
  }, [getFeaturedImage?.data?.data]);

  // console.log(bgImage)

  return (
    <Box
      sx={{
        backgroundImage: bgImage ? `url(${bgImage})` : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "50vh",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(90deg, rgba(13,96,168,1) 33%, rgba(0,0,0,0) 100%)",
          mixBlendMode: "multiply",
        }}
      />
      <Container
        maxWidth="xl"
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          color: "#fff",
          transform: "translateZ(1px)",
        }}
      >
        <Box
          sx={{
            width: {
              xs: "100%",
              md: "75%",
              xl: "50%",
            },
          }}
        >
          <Button
            component={RouterLink}
            to="/insights/"
            sx={{
              color: "#fff",
              border: "2px solid #fff",
              p: "0.5rem 1rem",
              borderRadius: "2rem",
              mb: "2rem",
              cursor: "pointer",
              fontSize: "0.875rem",
              position: "relative",
              transition: "all 0.2s ease-in-out",
              overflow: "hidden",
              fontWeight: "800",
              fontSize: "0.875rem",
              "&::after": {
                content: "''",
                position: "absolute",
                zIndex: "-1",
                transition: "all 0.2s ease-in-out",
                width: "100%",
                height: "0%",
                top: "0",
                left: "0",
                backgroundColor: "rgba(255,114,28,0.7)",
              },
              "&:hover": {
                "&::after": {
                  height: "100%",
                },
              },
            }}
          >
            <KeyboardDoubleArrowLeftIcon
              sx={{
                mr: "0.25rem",
                fontSize: "1rem",
              }}
            />
            More Insights
          </Button>
          <Typography
            variant="h1"
            sx={{
              fontSize: "2.4rem",
              fontWeight: 600,
              mb: "1rem",
            }}
            dangerouslySetInnerHTML={{
              __html: post
                ? he.decode(post.title.rendered)
                : `<Skeleton width="100%" height="2.4rem" />`,
            }}
          />

          {/* <Typography
                        variant='p'
                        component='p'
                        sx={{
                            fontSize: '1.1rem',
                            fontWeight: 500
                        }}
                        dangerouslySetInnerHTML={{
                            __html: post ? he.decode(post.excerpt.rendered) : `<Skeleton variant="rectangular" height={100} />`
                        }}
                    /> */}

          <Box
            sx={{
              mt: "2rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            {post?.categories &&
              post.categories.length > 0 &&
              post.categories.map((cat) => {
                const theCat = getTaxonomy(cat, post._embedded["wp:term"]);
                const featured = theCat.name === "Featured";
                return (
                  <>
                    <Button
                      sx={{
                        backgroundColor: featured ? "#E75421" : "#fff",
                        borderRadius: "50px",
                        color: featured ? "#fff" : "#000",
                        p: "0.5rem 0.75rem",
                        position: "relative",
                        zIndex: "2",
                        fontSize: "0.85rem",
                        fontWeight: "600",
                        mr: "0.5rem",
                        "&:hover": {
                          backgroundColor: "#0C5EAA",
                        },
                      }}
                      component={RouterLink}
                      to={theCat.link}
                    >
                      {he.decode(theCat.name)}
                    </Button>
                    {/* <Chip
                                        component={RouterLink}
                                        to={content.bg_link}
                                        label={he.decode(theCat.name)}
                                        sx={{
                                            backgroundColor: featured ? '#E75421' : '#fff',
                                            color: featured ? '#fff' : '#000',
                                            mr: '0.75rem',
                                            p: '0.5rem 0.25rem',
                                            fontSize: '0.85rem',
                                            fontWeight: 600
                                        }}
                                    /> */}
                  </>
                );
              })}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
